// Free MapLibre-compatible vector basemap from CARTO (no API key required).
// Voyager = light, color-rich style — much nicer than raw OSM raster tiles.
// See: https://github.com/CartoDB/basemap-styles
export const MAPLIBRE_OSM_STYLE: string =
  "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json";
